import { observer } from 'mobx-react';
import * as React from 'react';

export interface IDataCardProps {
    readonly title: string;
    readonly message: string;
    readonly className?: string;
    readonly color: string;
    readonly total: number;
}

@observer
export class DataCard extends React.Component<IDataCardProps> {
    public render() {
        return (
            <div className={this.props.className + ' data-card mb-1 text-white rounded'}>
                <div className={'container-fluid dashboard-display-background-' + this.props.color}>
                    <div className="row">
                        <div className="col-12 text-center py-2">
                            <div className="d-inline-block h-100">
                                <div className="flex-items-center h-100">
                                    {this.props.total + ' ' + this.props.title}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
